import {Action, createSelector} from '@ngrx/store';
import { EditUiState } from './EditUiState';
import {EditState} from '../EditState';
import {getEdit} from '../selectors';

const SET_SELECTED_TAB = '[edit ui] Set Selected Tab';
const VALIDATE_ERRORS = '[edit ui] Validate Errors';

const initState = {
  selectedTab: 0,
  showErrors: false,
};

export function editUiReducer(state: EditUiState = initState, action: SetSelectedTabAction | ValidateErrorsAction): EditUiState {
  switch (action.type) {
    case SET_SELECTED_TAB:
      return {
        ...state,
        selectedTab: action.payload,
      };
    case VALIDATE_ERRORS:
      return {
        selectedTab: action.payload,
        showErrors: true,
      };
    default:
      return state;
  }
}

export class SetSelectedTabAction implements Action {
  readonly type = SET_SELECTED_TAB;

  constructor(public payload: number) {}
}

export class ValidateErrorsAction implements Action {
  readonly type = VALIDATE_ERRORS;

  constructor(public payload: number) {}
}

export const getEditUi = createSelector(
  getEdit,
  (state: EditState) => state.editUi,
);

export const getShowErrors = createSelector(
  getEditUi,
  (state: EditUiState) => state.showErrors,
);
